/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const processAuditServices = {
	fetchProcessAuditList,
	fetchProcessAuditReview,
	createProcessAudit,
	transitionProcessAudit,
};

function fetchProcessAuditList(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.PROCESS_AUDITS_LIST, requestOptions).then(handleResponse);
}

function fetchProcessAuditReview(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.PROCESS_AUDITS_REVIEW, requestOptions).then(handleResponse);
}

function createProcessAudit(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.PROCESS_AUDITS_START, requestOptions).then((res) => {
		return res.json();
	});
}

/**
 * Unified lifecycle transition.
 * Payload: {auditId, storeId, targetStatus, comment?, adjustments?}
 */
function transitionProcessAudit(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.PROCESS_AUDIT_STATUS_CHANGE, requestOptions).then(handleResponse);
}

export default processAuditServices;
